import React from 'react'

export default function Badge({ children, color }) {
  const styles = {
    container: {
      display: 'inline-block',
      backgroundColor: color,
      padding: '3px 5px',
      fontSize: '0.7rem',
      color: 'white',
      borderRadius: 15,
    },
  }
  return <div style={styles.container}>{children}</div>
}
